export const ELEVATION_0 = "none";
export const ELEVATION_1 = "0px 1px 3px 1px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)";
export const ELEVATION_2 = "0px 2px 6px 2px rgba(0, 0, 0, 0.15), 0px 1px 2px 0px rgba(0, 0, 0, 0.3)";
export const ELEVATION_3 = "0px 1px 3px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)";
export const ELEVATION_4 = "0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px 6px 10px 4px rgba(0, 0, 0, 0.15)";
export const ELEVATION_5 = "0px 4px 4px 0px rgba(0, 0, 0, 0.3), 0px 8px 12px 6px rgba(0, 0, 0, 0.15)";
export const ELEVATION_5_RIGHT = "0px 4px 4px 0px rgba(0, 0, 0, 0.3), 0px 8px 12px 6px rgba(0, 0, 0, 0.15)";
export const ELEVATION_5_LEFT = "-0px 4px 4px 0px rgba(0, 0, 0, 0.3), -0px 8px 12px 6px rgba(0, 0, 0, 0.15)";

export const STICKY_TO_BOTTOM =
  "0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 1px 1px 0 rgba(0, 0, 0, 0.10), 0 2px 1px -1px rgba(0, 0, 0, 0.20), 0 -1px 5px -2px rgba(0, 0, 0, 0.15)";
